module.exports = __webpack_public_path__ + "img/avatar4.5f2b6ebc.png";